// extracted by mini-css-extract-plugin
export var indeterminate = "_20-6";
export var md = "_20-5";
export var semantic = "_20-7";
export var sm = "_20-4";
export var text = "_20-8";
export var toggleControl = "_20-0";
export var toggleInput = "_20-1";
export var toggleSwitch = "_20-2";
export var xs = "_20-3";